var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"icon":"","loading":_vm.requesting},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.clicked.apply(null, arguments)}}},'v-btn',_vm.$attrs,false),[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.icon)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }